// extracted by css-extract-rspack-plugin
export default {"checksRoot":"Checks-module__checksRoot__fU2S8"};